module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "g-bd"
  }, [_c('div', {
    staticClass: "m-tlt"
  }, [_vm._v("登录前请先验证安全手机："), _c('span', [_vm._v(_vm._s(_vm.mb))])]), _vm._v(" "), _c('Form', {
    ref: "form",
    staticClass: "m-form"
  }, [_c('form-item', {
    ref: "smsValidate",
    staticClass: "m-ipt ipt-h"
  }, [_c('urs-input', {
    ref: "smsInput",
    attrs: {
      "placeholder": "请输入短信验证码",
      "size": "small",
      "validate": _vm.validateSms
    }
  }, [_c('urs-button', {
    ref: "smsBtn",
    staticClass: "u-btn-sms",
    attrs: {
      "enableTip": "获取验证码",
      "count": _vm.smsCount
    },
    on: {
      "click": _vm.onGetSms
    },
    slot: "button"
  })], 1)], 1), _vm._v(" "), (_vm.showUp !== '') ? _c('div', {
    staticClass: "m-tlt del-bottom c-main",
    domProps: {
      "innerHTML": _vm._s(_vm.showUp)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-btns g-pd"
  }, [_c('urs-button', {
    ref: "submitBtn",
    attrs: {
      "enableTip": "确定"
    },
    on: {
      "click": _vm.onSubmit
    }
  })], 1)], 1)], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-ft g-pd clearfix c-main"
  }, [_c('a', {
    staticClass: "f-right",
    attrs: {
      "href": "https://gj.reg.163.com/faq/p4.html?ct=05"
    }
  }, [_vm._v("安全手机无法使用？")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cb3ca53"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Verifymb.vue
// module id = 512
// module chunks = 1